// document.addEventListener('DOMContentLoaded', function() {
//   var mainContentElement = document.getElementById('MainContent');
//   if (mainContentElement) {
//     mainContentElement.className = 'content-for-layout focus-none flex min-h-[calc(100vh_-_3rem)] flex-col justify-between lg:min-h-[calc(100vh_-_3.5rem)] xl:min-h-[calc(100vh_-_4.5rem)]';
//   }

//   var siteHeaderElement = document.getElementById('site-header');
//   if (siteHeaderElement) {
//     siteHeaderElement.classList.remove('header--white');
//     siteHeaderElement.classList.add('header--trans-white');
//   }
// });

document.addEventListener('DOMContentLoaded', function() {
  var mainContentElement = document.getElementById('MainContent');
  if (mainContentElement) {
    mainContentElement.className = 'content-for-layout focus-none flex min-h-[calc(100vh_-_3rem)] flex-col lg:min-h-[calc(100vh_-_3.5rem)] xl:min-h-[calc(100vh_-_4.5rem)]';
  }

  var siteHeaderElement = document.getElementById('megaheader');
  if (siteHeaderElement) {
    siteHeaderElement.classList.remove('megaheader--white');
    siteHeaderElement.classList.add('megaheader--trans-white');
  }
});